/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var DeclinedReasonType;

(function (DeclinedReasonType) {
  DeclinedReasonType["MANUAL"] = "manual";
  DeclinedReasonType["API"] = "api";
})(DeclinedReasonType || (DeclinedReasonType = {}));